var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _line, _path19, _path20, _path21, _path22, _rect, _rect2, _polygon, _polygon2, _line2, _polygon3, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlasticSurgery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -1 24.76 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2c355e;}.cls-15,.cls-2{fill:#5ba5ed;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#2c355e;}.cls-14,.cls-15,.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-2,.cls-4,.cls-5,.cls-6{stroke-width:0.5px;}.cls-3{fill:#161b43;}.cls-10,.cls-11,.cls-12,.cls-14,.cls-4{fill:#fff;}.cls-5{fill:#f7d9c1;}.cls-13,.cls-6,.cls-7,.cls-8,.cls-9{fill:none;}.cls-12,.cls-13,.cls-14,.cls-15,.cls-7,.cls-8,.cls-9{stroke-width:0.25px;}.cls-8{stroke-dasharray:0.52 0.52;}.cls-9{stroke-dasharray:0.5;}.cls-10,.cls-11,.cls-12,.cls-13{stroke-linecap:round;stroke-linejoin:round;}.cls-10{stroke-width:0.25px;}.cls-11{stroke-width:0.25px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,4.43C20,5.82,18.18,7,15.94,7s-4-1.13-4-2.52,1.87-3,4.11-3S20,3,20,4.43Z",
    transform: "translate(-3.97 -1.41)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,29.15c.07-1.84.27-3.33.27-3.33-2.34-1.61-5.69-2.05-8-2.15l-1.12,0-1.12,0c-2.28.1-5.63.54-8,2.15,0,0,.19,1.49.27,3.33Z",
    transform: "translate(-3.97 -1.41)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.24,29.15c-.16-1.29-.56-2.4-.8-3.55a5.5,5.5,0,0,0-3.12,3.55Z",
    transform: "translate(-3.97 -1.41)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.38,29.15a4.94,4.94,0,0,0-2.94-3.32c-.23,1.1-.6,2.13-.75,3.32Z",
    transform: "translate(-3.97 -1.41)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.25,22.06a4,4,0,0,1-2.37.7,4.29,4.29,0,0,1-2.42-.66v.5a5,5,0,0,0,2.42.94,4.87,4.87,0,0,0,2.37-1Z",
    transform: "translate(-3.97 -1.41)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.93,29.15l.77-5.26-1.28-.15a11.35,11.35,0,0,0-6.42.38l1.05,5Z",
    transform: "translate(-3.97 -1.41)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.92,26.5h-.11c-1.31,0-2.38-.28-2.38-1.6V20.36A2.39,2.39,0,0,1,15.81,18h.11a2.39,2.39,0,0,1,2.39,2.39V24.9C18.31,26.22,17.24,26.5,15.92,26.5Z",
    transform: "translate(-3.97 -1.41)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22,13.28a.91.91,0,0,0-.6.08c0-.33,0-.57,0-.67v-.11c0-.61-.41-5.68-5.82-5.63S10,12.09,10,12.7v.11c0,.11,0,.36.05.72a.9.9,0,0,0-.69-.09c-.67.2-1,1.21-.64,2.26s1.06,1.7,1.71,1.56a15,15,0,0,0,.51,2.33,5.33,5.33,0,0,0,5,3.49,5.5,5.5,0,0,0,4.81-3.59,15.41,15.41,0,0,0,.46-2.35h0c.67.15,1.41-.59,1.65-1.66S22.69,13.43,22,13.28Z",
    transform: "translate(-3.97 -1.41)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.81,4.44c9.44,0,5.92,10,5.13,10.22,0,0,.43-5.45-3.17-5.47-1.78,5.26-7.4,1.77-7,5.65C9.34,14,6.29,4.44,15.81,4.44Z",
    transform: "translate(-3.97 -1.41)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.27,13.93l1,3.21s.09.74-.58.78H15.62",
    transform: "translate(-3.97 -1.41)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.61,19.77a3,3,0,0,0,2.49-.09",
    transform: "translate(-3.97 -1.41)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M11.75,17a1.61,1.61,0,0,0,0,.25",
    transform: "translate(-3.97 -1.41)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M11.77,17.74a3.74,3.74,0,0,0,1,2.57",
    transform: "translate(-3.97 -1.41)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13,20.46l.22.12",
    transform: "translate(-3.97 -1.41)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.14,17v.25",
    transform: "translate(-3.97 -1.41)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20.12,17.74a3.74,3.74,0,0,1-1,2.57",
    transform: "translate(-3.97 -1.41)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M18.86,20.46l-.22.12",
    transform: "translate(-3.97 -1.41)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.32,21.65a2.41,2.41,0,0,0,3.05,0",
    transform: "translate(-3.97 -1.41)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 11.9,
    y1: 19.01,
    x2: 11.9,
    y2: 20.83
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.53,13.75a2,2,0,0,1,2.88,0",
    transform: "translate(-3.97 -1.41)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.41,15.06a2.1,2.1,0,0,1-2.56.28",
    transform: "translate(-3.97 -1.41)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.64,14.06a2,2,0,0,0-2.88,0",
    transform: "translate(-3.97 -1.41)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.76,15.38a2.11,2.11,0,0,0,2.55.28",
    transform: "translate(-3.97 -1.41)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 24.81,
    y: 20.73,
    width: 0.77,
    height: 2.09,
    transform: "translate(-4.17 -1.16) rotate(-0.55)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 24.6,
    y: 18.67,
    width: 1.15,
    height: 2.06,
    transform: "translate(-4.18 -1.12) rotate(-0.64)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "21.54 17.26 20.81 17.26 20.81 16.92 21.54 16.91 21.54 17.26"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "21.41 16.91 20.95 16.92 21.02 14.03 21.26 14.03 21.41 16.91"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 21.15,
    y1: 14.03,
    x2: 21.12,
    y2: 11.25
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "20.82 17.82 20.82 17.82 22.04 18.8 22.04 18.8 20.82 17.82"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M28.13,16.92l-.07-3.8a1.07,1.07,0,0,0-.89,1.25l.06,1.24.27.45,0,1.21.13.6.36-.19Z",
    transform: "translate(-3.97 -1.41)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M28.31,16.45l.09,6.07a.28.28,0,0,1-.28.29h-.45a.3.3,0,0,1-.29-.28l-.08-5.72Z",
    transform: "translate(-3.97 -1.41)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticSurgery);
export default __webpack_public_path__ + "static/media/plastic_surgery.f5405a4fdf30c23d67c20d523986c164.svg";
export { ForwardRef as ReactComponent };